import { createCustomMetric } from '@confluence/browser-metrics/entry-points/metricConfigs';
import { PROFILE_CARD_QUERY_CUSTOM_KEY } from '@confluence/browser-metrics/entry-points/metric-keys';
export const PROFILE_CARD_QUERY_METRIC = createCustomMetric({
	key: PROFILE_CARD_QUERY_CUSTOM_KEY,
});
